<div class="image">

</div>

<!-- Your logo on the top left -->
<a href="#" class="logo-link" title="back home">

    <img src="assets/images/logo.png" class="logo" alt="Logotipo Empresa" />

</a>

<div class="content">

    <div class="content-box">

        <div class="big-content">

            <!-- Main squares for the content logo in the background -->
            <div class="list-square">
                <span class="square"></span>
                <span class="square"></span>
                <span class="square"></span>
            </div>

            <!-- Main lines for the content logo in the background -->
            <div class="list-line">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
            </div>

            <!-- The animated searching tool -->
            <i class="fa fa-search" aria-hidden="true"></i>

            <!-- div clearing the float -->
            <div class="clear"></div>

        </div>

        <!-- Your text -->
        <h1>404 Página no Encontrada</h1>

        <p>La página que buscas no existe.</p>

    </div>

</div>
<footer class="light">

    <ul>
        <li><a [routerLink]="['/']">Regresar</a></li>
    </ul>

</footer>